import FormControlLabel from "@material-ui/core/FormControlLabel";
import Input from "../../../../../components/Input";
import InputSelect from "../../../../../components/Input-select";
import { AutoCompleteList } from "../../../../../libs/autoCompleteList";
import { SwitchBlue } from "../../../../../libs/switch";
import { CASES_FILTER_COLLABORATORS, SELECT_CASES_FILTER_COLLABORATORS } from "../constants";
import useStoreGridCollaborator from "../store/useStore";

export default function FilterGridCollaborator() {
  const {
    filterValue,
    selectFilter,
    inactiveOrActive,
    setFilterValue,
    setSelectFilter,
    handleInputFilterCollaborator,
    setStateFunction,
    setPage,
    collaboratorsDeleted,
    collaboratorActivated,
    saveValuesFilter,
    collaboratorsOriginal,
  } = useStoreGridCollaborator();

  function handleCleanFilter() {
    setFilterValue("");
    setSelectFilter(0);
    setPage(0);
    saveValuesFilter(collaboratorsOriginal);
  }

  return (
    <>
      <datalist id="datalist">
        {AutoCompleteList(inactiveOrActive ? collaboratorsDeleted : collaboratorActivated, [CASES_FILTER_COLLABORATORS[selectFilter - 1]])?.map(
          (itemListFilter) => {
            return <option>{itemListFilter}</option>;
          },
        )}
      </datalist>

      <div className="wrapperFilterContainer between flex">
        <div className="rowFilterContainer">
          <Input
            className="filter-collaborator-input inputContainer"
            name="collaborator"
            type="search"
            label="Buscar"
            placeholder="Busque um profissional"
            value={filterValue}
            list="datalist"
            setValue={(event: any) => setFilterValue(event.target.value)}
          />

          <InputSelect
            className="inputContainer"
            name="search"
            label="Filtro"
            placeholder="Pesquisar"
            value={selectFilter}
            onChange={(event: any) => setSelectFilter(event.target.value)}
            list={SELECT_CASES_FILTER_COLLABORATORS}
          />
          <div className="box-filter-btn-collaborator flex btnContainer m-top10">
            <button className="btn filter-btn bg-primary m-top10" onClick={handleInputFilterCollaborator}>
              Filtrar
            </button>
            <button className="Link btn bg-secondary m-top10" onClick={handleCleanFilter}>
              Limpar
            </button>
          </div>
        </div>

        <div className="rowFilterSwitchItem">
          <FormControlLabel
            className="switch switch-collaborator m-top10"
            control={
              <SwitchBlue
                checked={inactiveOrActive}
                onChange={setStateFunction}
                disabled={collaboratorsDeleted?.length ? false : true}
                name="checkedB"
              />
            }
            label="ver inativos"
          />
        </div>
      </div>
    </>
  );
}
